import { cn } from '@/app/utils/cn';

import styles from './styles.module.css';

export const desktopMaxWidthFormClassName = cn('md:max-w-142 md:px-0 xl:px-0');
export const desktopMaxWidthClassName = cn(
  'mx-auto md:max-w-162 md:px-0 xl:px-0'
);

/** Coupon background: the tier's gradient, or a plain colour without a tier. */
export const getTierBackgroundStyles = (tier?: string | null) => ({
  [styles.summaryBgNoTier]: !tier,
  [styles.summaryBgSilver]: tier === 'my-SILVER',
  [styles.summaryBgGold]: tier === 'my-GOLD',
  [styles.summaryBgPlatinum]: tier === 'my-PLATINUM',
  [styles.summaryBgDiamond]: tier === 'my-DIAMOND',
});

/** Translucent panel behind the coupon header. */
export const getTierHeaderOverlayStyles = (tier?: string | null) => ({
  [styles.headerOverlayNoTier]: !tier,
  [styles.headerOverlaySilver]: tier === 'my-SILVER',
  [styles.headerOverlayGold]: tier === 'my-GOLD',
  [styles.headerOverlayPlatinum]: tier === 'my-PLATINUM',
  [styles.headerOverlayDiamond]: tier === 'my-DIAMOND',
});
